import { BillingDetails, ExpressCheckoutAddress, ShippingAddress } from "@stripe/stripe-js";

// Apple Pay lets customers pay with a saved contact that predates iOS's own address validation,
// so line1/city/postal_code/country can be missing.
export function isCompleteAddress(address?: ExpressCheckoutAddress): boolean {
	return (
		!!address?.line1 &&
		!!address?.city &&
		!!address?.country &&
		(address.country !== "GB" || !!address?.postal_code)
	);
}

export function isCompleteShippingAddress(shippingAddress?: ShippingAddress): boolean {
	return !!shippingAddress?.name && isCompleteAddress(shippingAddress?.address);
}

export function isCompleteBillingDetails(billingDetails?: BillingDetails): boolean {
	return !!billingDetails?.name && isCompleteAddress(billingDetails?.address);
}

// From Gibe.Validation.Constants.Regex.Email
const EMAIL_REGEX = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;

// From Site.Constants.Validation.PhoneNumberRegex
const PHONE_REGEX = /^[-/()+0-9 ]+$/;

const CHANNEL_ISLANDS_POSTCODE_PATTERN = /^(GY|JE[1-5])/i;

export function isCompleteContactDetails(billingDetails?: BillingDetails): boolean {
	return (
		!!billingDetails?.email && EMAIL_REGEX.test(billingDetails.email) &&
		!!billingDetails?.phone && PHONE_REGEX.test(billingDetails.phone)
	);
}

export function isChannelIslandsPostcode(postcode?: string | null): boolean {
	return CHANNEL_ISLANDS_POSTCODE_PATTERN.test((postcode ?? "").replace(/\s/g, ""));
}
